// Gemerkte Ansicht einer Liste je Nutzer (Spalten, Sortierung, Breiten) für Kontakte und Aktivitäten. Seit dem Feinschliff vom
// 16.10.2026 über denselben Speicher wie die Lead-Listen (`daten/listenAnsichtStore`): Änderungen erscheinen sofort und werden
// im Hintergrund gespeichert (Fehler der Route stören die Liste nicht, die Wahl gilt dann nur bis zum Neuladen).
import { useGemerkteAnsicht as useAnsichtStore, type AnsichtZugriff } from "../../daten/listenAnsichtStore";
import type { AnsichtEingabe, GemerkteAnsicht } from "../../api/listenAnsichten";

export interface GemerkteAnsichtZustand {
  /** undefined: wird geladen, null: keine gemerkte Ansicht (Standard) */
  ansicht: GemerkteAnsicht | null | undefined;
  merken: (teil: AnsichtEingabe) => void;
  /** derselbe Zugriff in der Form des Speichers (für Spaltenbreiten und Verschieben) */
  zugriff: AnsichtZugriff;
}

export function useGemerkteAnsicht(liste: string): GemerkteAnsichtZustand {
  const zugriff = useAnsichtStore(liste);
  return { ansicht: zugriff.geladen ? zugriff.ansicht : undefined, merken: zugriff.aendern, zugriff };
}
